import { Grid, TextField } from '@mui/material';
import { IDepotAsset } from '../../../../../../Interfaces/Asset/IDepotAsset';
import { ITestamentAssetsViewProps } from '../../../../../../Interfaces/Asset/ITestamentAssetsViewProps';

type DepotAssetViewProps = ITestamentAssetsViewProps<IDepotAsset>;

export function DepotAssetView({ asset, setAsset }: DepotAssetViewProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextField
          label='Name des Brokers'
          size='small'
          value={asset.data.brokerName || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                brokerName: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label='Depotnummer'
          size='small'
          value={asset.data.depotNumber || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                depotNumber: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Gesamtwert des Depots in Euro'
          size='small'
          value={asset.data.value}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                value: Number(event.target.value),
              },
            })
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Sonstige Informationen'
          rows={2}
          size='small'
          multiline
          value={asset.data.notes || ''}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setAsset({
              ...asset,
              data: {
                ...asset.data,
                notes: event.target.value || '',
              },
            })
          }
          fullWidth
        />
      </Grid>
    </Grid>
  );
}
